<template>
  <div>
    <notifications />

    <div class="header bg-gradient-success py-7 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-5">
          <!-- <img
            src="img/brand/rajdoot.jpeg"
            class="h-50"
            alt=""> -->
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">Create Service Request</h1>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-default" points="2560 0 2560 100 0 100" />
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <!-- Table -->
      <div class="row justify-content-center">
        <div class="col-lg-6 col-md-8">
          <div class="card bg-secondary border-0">
            <div class="card-body px-lg-5 py-lg-5">
              <form role="form">
                <base-input label="Select Customer">
                  <el-select
                    :remote-method="searchUserByPhone"
                    :loading="loading"
                    v-model="serviceRequest.userId"
                    remote
                    filterable
                    placeholder="Search By Phone"
                    @change="getUserAddresses"
                  >
                    <el-option
                      v-for="(item, index) in users"
                      :key="index"
                      :value="item.userId"
                      :label="item.firstName + ' ' + item.lastName"
                    />
                  </el-select>
                </base-input>
                <base-input label="Select Address">
                  <el-select
                    v-model="serviceRequest.customerAddressId"
                    filterable
                  >
                    <el-option
                      v-for="(item, index) in addresses"
                      :key="index"
                      :value="item.customerAddressId"
                      :label="item.address + '(' + item.addressMarathi + ')'"
                    />
                  </el-select>
                </base-input>

                <base-input label="Type" tabindex="1">
                  <el-radio
                    v-model="serviceRequest.isOnSite"
                    :label="true"
                    @change="fetchCategories()"
                    >On Site</el-radio
                  >
                  <el-radio
                    v-model="serviceRequest.isOnSite"
                    :label="false"
                    @change="fetchCategories()"
                    >Workshop Only</el-radio
                  >
                </base-input>

                <base-input label="Select Category">
                  <el-select
                    v-model="categoryId"
                    filterable
                    @change="fetchSubcategories"
                  >
                    <el-option
                      v-for="(item, index) in categories"
                      :key="index"
                      :value="item.serviceCategoryId"
                      :label="item.label"
                    />
                  </el-select>
                </base-input>

                <base-input v-if="categoryId" label="Select Subcategory">
                  <el-select
                    v-model="subcategoryId"
                    filterable
                    @change="fetchServiceJobs"
                  >
                    <el-option
                      v-for="(item, index) in subcategories"
                      :key="index"
                      :value="item.serviceId"
                      :label="item.label"
                    />
                  </el-select>
                </base-input>

                <base-input v-if="subcategoryId" label="Select Jobs">
                  <el-select v-model="selectedJobs" filterable multiple>
                    <el-option
                      v-for="(item, index) in jobs"
                      :key="index"
                      :value="item.serviceJobId"
                      :label="item.label"
                    />
                  </el-select>
                </base-input>
                <base-input label="Select Priority">
                  <el-radio-group v-model="serviceRequest.priority">
                    <el-radio label="high">High</el-radio>
                    <el-radio label="moderate">Moderate</el-radio>
                    <el-radio label="low">Low</el-radio>
                  </el-radio-group>
                </base-input>

                <base-input label="Description" tabindex="5">
                  <el-input v-model="serviceRequest.description" type="text" />
                </base-input>

                <div class="text-center">
                  <button
                    type="button"
                    class="btn btn-primary mt-4"
                    @click="saveRequest()"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Select, Option, Radio, Dialog, RadioGroup } from "element-ui";
import { mapActions, mapState } from "vuex";
export default {
  name: "Register",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Dialog.name]: Dialog,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup
  },
  data() {
    return {
      loading: false,
      value: "",
      categoryId: "",
      subcategoryId: "",
      serviceRequest: {
        userId: "",
        vendorId: "",
        priority: "moderate",
        description: "",
        isOnSite: true,
        customerAddressId: ""
      },
      categories: [],
      addresses: [],
      users: [],
      selectedJobs: [],
      selectedAddress: ""
    };
  },
  computed: {
    ...mapState("noAuth", ["subcategories", "jobs", "vendors", "adminUser"])
  },
  beforeMount() {
    this.fetchCategories();
    this.getVendors();
    this.getAdminUser();
  },

  methods: {
    ...mapActions({
      getAdminUser: "noAuth/getAdminUser",
      getUserByPhone: "noAuth/getUserByPhone",
      getServiceCategories: "noAuth/getServiceCategories",
      getSubcategoriesByCategoryId: "noAuth/getSubcategoriesByCategoryId",
      getServiceJobs: "noAuth/getServiceJobs",
      getVendors: "noAuth/getVendorList",
      saveServiceRequest: "noAuth/saveServiceRequest",
      getAddresses: "noAuth/getUserAddresses"
    }),
    searchUserByPhone(query) {
      if (query !== "" && query.length === 10) {
        this.getUserByPhone(query).then(res => {
          this.users = res.data;
        });
      }
    },
    fetchCategories() {
      this.getServiceCategories().then(res => {
        if (this.serviceRequest.isOnSite) {
          const result = res.filter(i =>
            ["electrician", "motor mechanic"].includes(i.label.toLowerCase())
          );
          this.categories = result;
        } else {
          const result = res.filter(i =>
            ["appliances repair", "quotation"].includes(i.label.toLowerCase())
          );
          this.categories = result;
        }
      });
    },
    fetchSubcategories(categoryId) {
      this.subcategoryId = "";
      this.selectedJobs = [];
      this.getSubcategoriesByCategoryId(categoryId);
    },

    fetchServiceJobs(id) {
      this.selectedJobs = [];
      this.getServiceJobs(id);
    },

    getUserAddresses(userId) {
      this.getAddresses(userId).then(res => {
        this.addresses = res;
      });
    },

    saveRequest() {
      const serviceJobsMeta = this.selectedJobs.map(i => {
        return [this.categoryId, this.subcategoryId, i];
      });
      const data = {
        ...this.serviceRequest,
        date: new Date(),
        serviceJobsMeta,
        createdBy: this.adminUser.userId,
        externalGoodsMeta: {}
      };
      if (this.serviceRequest.vendorId === "") {
        delete data.vendorId;
      }
      this.saveServiceRequest(data).then(res => {
        this.$notify({
          message: "Service Request Added Succesfully!",
          type: "success",
          title: "Succes"
        });
        this.serviceRequest = {
          userId: "",
          vendorId: "",
          priority: "moderate",
          description: "",
          isOnSite: true
        };
        this.categoryId = "";
        this.subcategoryId = "";
      });
    }
  }
};
</script>
<style></style>
